import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, mergeMap, of, switchMap, withLatestFrom } from 'rxjs';
import { VehiclesService } from '../../general/shared/services/vehicles/vehicles.service';
import { loadVehicles, loadVehiclesSuccess, reloadVehicles } from './vehicles.actions';
import { VehiclesState, vehiclesStateFeature } from './vehicles.state';

@Injectable()
export class VehiclesStateEffects {
	constructor(
		private actions$: Actions,
		private vehiclesService: VehiclesService,
		private store: Store<VehiclesState>
	) {}

	loadVehicles$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(loadVehicles),
				withLatestFrom(this.store.select(vehiclesStateFeature.selectVehicles)),
				switchMap(([action, latest]) => {
					// If action.value is falsy → return empty array
					if (action.value?.length === 0) {
						return of([]).pipe(map((vehicles) => loadVehiclesSuccess({ value: vehicles })));
					}

					// If we already have vehicles, reuse them
					if (latest?.length) {
						return of(latest).pipe(map((vehicles) => loadVehiclesSuccess({ value: vehicles })));
					}

					// Otherwise load them from the service
					return this.vehiclesService
						.loadVehicles(action.value)
						.pipe(map((vehicles) => loadVehiclesSuccess({ value: vehicles })));
				})
			),
		{ dispatch: true }
	);

	reloadVehicles$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(reloadVehicles),
				switchMap((action) =>
					this.vehiclesService
						.loadVehicles(action.value)
						.pipe(mergeMap((vehicles) => [loadVehiclesSuccess({ value: vehicles })]))
				)
			),
		{ dispatch: true }
	);
}
